import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// --- Silent access-token refresh on 401 -----------------------------------
// The backend issues an 8h access cookie and a 7d refresh cookie. Without a
// client-side hook, an expiring access cookie would surface as a "random"
// logout mid-work. This interceptor transparently calls /auth/refresh once
// on any 401 (other than the auth endpoints themselves) and replays the
// failed request. Only if refresh itself fails do we surface the 401.
let refreshInFlight = null;
const isAuthPath = (url = "") => {
  const u = String(url);
  return u.includes("/auth/login") || u.includes("/auth/refresh") || u.includes("/auth/logout") || u.includes("/auth/me");
};
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const status = error.response?.status;
    if (status !== 401 || original._retried || isAuthPath(original.url)) {
      return Promise.reject(error);
    }
    original._retried = true;
    try {
      // Coalesce concurrent 401s onto a single refresh call.
      refreshInFlight = refreshInFlight || api.post("/auth/refresh").finally(() => { refreshInFlight = null; });
      await refreshInFlight;
      return api(original);
    } catch (refreshErr) {
      return Promise.reject(error);
    }
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
